module.exports = __webpack_public_path__ + "img/0-76.e22b85ad.jpg";